<template>
  <input class="form-control" type="text" min="0" v-model="displayValue" @blur="isInputActive = false" @focus="isInputActive = true" @keyup="isNumber">
</template>
<script>
  export default {
    props: ["value", "sign"],
    data() {
      return {
        isInputActive: false,
      }
    },
    computed: {
      displayValue: {
        get: function () {
          if (this.isInputActive) {
            // Cursor is inside the input field. unformat display value for user
            if (this.value) {
              return this.value.toString()
            }

          } else {
            var sign_ = '$'
            var val = 0;
            if (this.sign) {
              sign_ = this.sign;
            }
            if (this.value) {
              val = this.value
            }
            //console.log(val)
            // User is not modifying now. Format display value for user interface
            return sign_ + " " + parseFloat(val).toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
          }
        },
        set: function (modifiedValue) {
          // Recalculate value after ignoring "$" and "," in user input
          let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ""))
          // Ensure that it is not NaN
          if (isNaN(newValue)) {
            newValue = 0
          }
          // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
          // $emit the event so that parent component gets it
          this.$emit('input', newValue)
        }
      }

    },
    methods: {
      isNumber(n) {
        //console.log(n);
        n.target.value = n.target.value.replace(/[^\d.-]/g, '');
      },
    },
  };

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/CurrencyNumber.vue